// @flow
import React from "react";
import { StaggeredMotion, spring } from "react-motion";

const bouncySpringPreset = {
  stiffness: 30,
  damping: 16
};

const FadeInText = ({
  items,
  targetValue
}: {
  items: Array<any>,
  targetValue: number
}) =>
  <div>
    <StaggeredMotion
      defaultStyles={items.map(i => ({ y: 0 }))}
      styles={styles =>
        styles
          ? styles.map((_, i, arr) => {
              return i === 0
                ? { y: spring(targetValue, bouncySpringPreset) }
                : {
                    y: spring(arr[i - 1].y, bouncySpringPreset)
                  };
            })
          : []}
    >
      {styles =>
        <div className="items">
          {items.map((item, i) =>
            <div
              key={i}
              className="item"
              style={{
                opacity: styles[i].y
              }}
            >
              {item}
            </div>
          )}
        </div>}
    </StaggeredMotion>
    <style jsx>{`
        .items {
          position: relative;
        }
        .item {
          position: relative;
        }
      `}</style>
  </div>;

export default FadeInText;



// WEBPACK FOOTER //
// ./src/components/Quiz/FadeInText.js